// extracted by mini-css-extract-plugin
export var compactFilters = "_fv-4";
export var detailImage = "_fv-1";
export var dropdownContainer = "_fv-2";
export var imageContainer = "_fv-0";
export var selectedCard = "_fv-3";